export const CART_REQUEST_ADDED = '@@cart/CART_REQUEST_ADDED';
export const CART_REQUEST_EMPTY = '@@cart/CART_REQUEST_EMPTY';
export const CART_UPDATE_QUANTITY = '@@cart/CART_UPDATE_QUANTITY';
export const CART_UPDATE_ITEM = '@@cart/CART_UPDATE_ITEM';
export const CART_UPDATE_DELIVERY_FEE = '@@cart/CART_UPDATE_DELIVERY_FEE';
export const CART_UPDATE_DELIVERY_DISTANCE = '@@cart/CART_UPDATE_DELIVERY_DISTANCE';
